import React from 'react';
import './CostReduction.css';

const CostReduction = () => {
  const benefits = [
    {
      icon: 'fas fa-dollar-sign',
      title: '70% Cost Reduction',
      description: 'Traditional drip systems require expensive equipment and skilled installation teams. Our autonomous robots eliminate these barriers, reducing total system costs by up to 70%.'
    },
    {
      icon: 'fas fa-user-times',
      title: 'No Specialized Labor Required',
      description: 'Farmers can deploy our system themselves without hiring expensive installation crews or learning complex technical procedures. One robot can handle what previously required a full team.'
    }
  ];

  return (
    <section className="cost-reduction">
      <div className="container">
        <h2>Dramatically Reduce Irrigation Costs</h2>
        <p className="section-subtitle">
          Our robotic system eliminates expensive specialized labor and complex equipment, making drip irrigation accessible to smallholder farmers worldwide.
        </p>
        
        <div className="cost-content">
          <div className="cost-benefits">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item">
                <div className="benefit-icon">
                  <i className={benefit.icon}></i>
                </div>
                <div className="benefit-content">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="cost-comparison">
            <h3>Cost Comparison</h3>
            <div className="comparison-table">
              <div className="comparison-row traditional">
                <span className="system-type">Traditional System</span>
                <span className="cost-range">$2,500 - $4,000</span>
              </div>
              <div className="comparison-row robotic">
                <span className="system-type">Our Robotic System</span>
                <span className="cost-range">$750 - $1,200</span>
              </div>
            </div>
            <div className="savings-highlight">
              <div className="savings-amount">Save $1,300+</div>
              <div className="savings-label">Per Installation</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CostReduction;
